/**
 * Distinguishes shipping vs billing in forms, profile/cart mappers, and order UI.
 * Use `AddressType.Shipping` / `AddressType.Billing` (string values `"shipping"` | `"billing"`).
 */
// eslint-disable-next-line import/prefer-default-export -- shared named enum
export enum AddressType {
  Shipping = 'shipping',
  Billing = 'billing',
}
